import React from 'react';
import {Image} from 'react-bootstrap'
import {observer, inject} from 'mobx-react'

@observer
export default class CardAttachmentImage extends React.Component {
    constructor(props) {
        super(props);


        this.state = {}
    }

    render() {

        const {attachments} = this.props;

        if (!attachments) {
            return null;
        }

        const att = attachments.find((att) => {
            return att.attachmentName.match(/.(jpg|jpeg|png|gif)$/i)
        });

        if (!att) {
            return null;
        }

        return (
            <div className="react-note-image-container"
                 onClick={this.showImageInNewWindow.bind(null, att.attachmentUrl)}>
                <Image src={att.attachmentUrl} thumbnail/>
            </div>
        );
    }


    showImageInNewWindow = (src, e) => {
        // e.preventDefault();
        // e.stopPropagation();
        // window.open(src)
    };
}

